<template>
  <van-action-sheet
    v-model="showActionSheet"
    cancel-text="取消">
    <div class="share-content">
      <div class="title">立即分享给家长</div>
      <div class="img-nav" @click="prewView">
        <img :src="imageUrl ">
        <div class="preview-tips">查看海报</div>
      </div>
      <div class="tips">长按海报保存到本地</div>
    </div>
  </van-action-sheet>    
</template>
<script>

import { util } from '@mlib/js/poster/util/render.js';

export default {
  name: "nofityBindAccount",
  data () {
    return {
      imageUrl: '',
      showActionSheet: false,
    }
  },
  methods:{
    getQrCodeImg(params) {
      vant.Toast.loading();
      return new Promise(async (resolve,reject) =>{      
        const list = params.commentContent.list;
        const textObj = list.find(item=>item.type == 'text' || item.type==='aitext');
        let text = '';
        if (textObj) {
          text = textObj.content;
        }
        const imgObj =  list.find(item=>item.type == 'image');
        let img = 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/share/comment-share.png';
        if (imgObj) {
          img = imgObj.url;
        }
        const date = new Date(params.date);
        const day = app.tool.date.formatDatetime(date, 'dd');
        const yearMonth = app.tool.date.formatDatetime(date, 'yyyy.MM');     
        
        const avatar = params.sex === 0 ? 'avatar-2' : params.sex === 1 ? 'avatar-1' : 'avatar-0';

        const poster = app.getPoster({
          width: 686,
          height: 1120,
          // radius: 16,
          shapes: [
            {
              type: "img",
              render: "img",
              content: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/comment-poster.png',
              offset: {
                left: 0,
                top: 0,
                width: "w",
                height: "h",
              },
            },
            {
              type: "img",
              render: "img",
              content: this.qrCode,
              offset: {
                bottom: 'h - 150',
                right: 'w - 76',
                width: 140,
                height: 140,
              },
            },
            {
              id: 'avatar',
              type: "img",
              render: "img-circle",
              content: `https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/${avatar}.png`,
              offset: {
                left: 74,
                top: 72,
                width: 72,
                height: 72,
              },
            },
            {
              id: '$name',
              type: 'text',
              render: 'text',
              content: params.name,
              offset: {
                left: 'avatar.right + 14',
                top: 72,
                width: 300,
                height: 40,
              },
              other: {
                font: 'bold 28px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#323233',
                lineHeight: 40,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: params.curriculumName,
              offset: {
                left: '$name.left',
                top: '$name.bottom',
                width: 450,
                height: 32,
              },
              other: {
                font: 'normal 20px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#969799',
                lineHeight: 40,
              }
            },
            {
              type: "img",
              render: "img",
              content: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/feiji.png',
              offset: {
                top: 10,
                right: 'w',
                width: 194,
                height: 140,
              },
            },
            {
              id: '$img',
              type: "img",
              render: "img-clip",
              content: img,
              offset: {
                top: 200,
                left: 66,
                width: 556,
                height: 396,
              },
              other: {
                radius: 8,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: text,
              offset: {
                left: '$img.left',
                top: '$img.bottom + 12',
                width: 556,
                height: 144,
              },
              other: {
                font: 'normal 28px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#323233',
                lineHeight: 48,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: day,
              offset: {
                left: 88,
                bottom: 'h - 186',
                width: 70,
                height: 56,
              },
              other: {
                font: 'normal 56px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#FFFFFF',
                lineHeight: 56,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: yearMonth,
              offset: {
                left: 178,
                bottom: 'h - 220',
                width: 120,
                height: 40,
              },
              other: {
                font: 'normal 28px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#00B8FF',
                lineHeight: 40,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: params.week,
              offset: {
                left: 178,
                bottom: 'h - 180',
                width: 120,
                height: 40,
              },
              other: {
                font: 'normal 28px PingFangSC-Medium, PingFang SC, sans-serif',
                color: '#00B8FF',
                lineHeight: 40,
              }
            },
            {
              type: 'text',
              render: 'text',
              content: params.companyName,
              offset: {
                left: $ => ($.w - $.textWidth) / 2,
                bottom: 'h - 44',
                width: ($)=>  $.textWidth,
                height: 34,
              },
              inject: {
                textWidth(context,pos, shape){
                  return util(context).calcTextWidth(600, shape);
                }
              },
              other: {
                font: 'normal 24px PingFangSC-Medium, PingFang SC, sans-serif',
                color: 'rgba(2, 185, 255, 0.55)',
                lineHeight: 34,
              }
            },

          ],
        });
        poster.getPng().then((url) => {
          this.imageUrl = url;
          resolve()
        }, reject);        
      }).finally(()=>{
        vant.Toast.clear();
      })
      
 
     
    },
    prewView() { 
      vant.ImagePreview({
        showIndex: false,
        className: 'show-poster-preview',
        images: [this.imageUrl],
      });
    },
    async open (params) {
      const QRCode = await app.libs.getQrCodeJs();
      let divDom = document.createElement('div');
      new QRCode(divDom, params.link);
      await new Promise(rsv => setTimeout(rsv, 0));
      const cvs = divDom.firstElementChild;
      this.qrCode = cvs.toDataURL('image/png');
      await this.getQrCodeImg(params);
      this.showActionSheet = true;
    },
  },
}
</script>
<style lang="scss" scoped>
.qrcode-container{
  transform: translate3d(-10000px,-10000px,-1px);
  position: absolute;
}
.share-content{
    max-height: 100%;
    overflow-y: auto;
  .title,
  .tips{
    margin: calc(var(--gap) * 10) auto calc(var(--gap) * 12);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    font-weight: 400;
    text-align: center;
  }
  .img-nav{
    position: relative;
    margin: auto;
    height: 393px;
    width: 241px;
    >img{
      outline: none;
      border: none;
      width: 100%;
      height: 100%;
    }
    .preview-tips{
      position: absolute;
      bottom: 0;
      left: 0;
      color: var(--white);
      padding: calc(var(--gap) * 5) calc(var(--gap) * 11);
      border-radius: 0 var(--radius-sm) 0 var(--radius-sm);
      background: rgba(var(--black-rgb), 0.8);
      opacity: 0.9;
    }
  }
  .tips{      
    margin: calc(var(--gap) * 8) auto calc(var(--gap) * 12);
    color: var(--g6);
  }
}
</style>